import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { UserRole } from './../../../types/UserRole';
import { mutationKeys } from '../mutationKeys';

export const postUserRole = async (formData: UserRole) => {
  const response = await CustomAxios.post(`user_roles`, formData);
  const { data } = response;
  return data;
};

type useCreateUserRoleProps = {
  onSuccessCallback: (data: UserRole) => void;
};
export function useCreateUserRole({ onSuccessCallback }: useCreateUserRoleProps) {
  return useMutation({
    mutationKey: [mutationKeys.createUserRole],
    mutationFn: (formData: UserRole) => postUserRole(formData),
    onSuccess: (data: UserRole) => {
      // fetch the userRoles again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allUserRoles, 'new'] });

      // call success
      onSuccessCallback(data);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        // let set the query data with bad errored response
        const userRole: UserRole = err.response.data as UserRole;
        queryClient.setQueryData([queryKeys.allUserRoles, 'new'], userRole);
      }
    },
  });
}
